import { render, staticRenderFns } from "./addedit-vessel.vue?vue&type=template&id=2b241245"
import script from "./addedit-vessel.vue?vue&type=script&lang=js"
export * from "./addedit-vessel.vue?vue&type=script&lang=js"
import style0 from "./addedit-vessel.vue?vue&type=style&index=0&id=2b241245&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports